const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Dashboard = () => import('~/pages/dashboard').then(m => m.default || m)

const BuildingList = () => import('~/pages/buildings').then(m => m.default || m)
const BuildingDetail = () => import('~/pages/buildings/detail').then(m => m.default || m)
const BuildingDetailFolder = () => import('~/pages/buildings/folder').then(m => m.default || m)
const BuildingEdit = () => import('~/pages/buildings/edit').then(m => m.default || m)
const BuildingAdd = () => import('~/pages/buildings/add').then(m => m.default || m)

const UserList = () => import('~/pages/users').then(m => m.default || m)
const UserEdit = () => import('~/pages/users/edit').then(m => m.default || m)
const UserAdd = () => import('~/pages/users/add').then(m => m.default || m)
const UserClaim = () => import('~/pages/users/claim').then(m => m.default || m)

const OrgList = () => import('~/pages/orgs').then(m => m.default || m)
const OrgView = () => import('~/pages/orgs/view').then(m => m.default || m)
const OrgEdit = () => import('~/pages/orgs/edit').then(m => m.default || m)
const OrgAdd = () => import('~/pages/orgs/add').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

export default [
    {path: '/', name: 'dashboard', component: Dashboard},

    {path: '/login', name: 'login', component: Login},
    {
        path: '/password/reset',
        name: 'password.request',
        component: PasswordEmail
    },
    {
        path: '/password/reset/:token',
        name: 'password.reset',
        component: PasswordReset
    },

    {
        path: '/auth/claim/:email/:token',
        name: 'auth.claim',
        component: UserClaim
    },

    {
        path: '/buildings',
        name: 'buildings',
        component: BuildingList
    },
    {
        path: '/buildings/:buildingId',
        component: BuildingDetail,
        children: [
            {path: '', redirect: {name: 'building.detail.folder'}},
            {
                path: 'folder/:folderId?',
                name: 'building.detail.folder',
                component: BuildingDetailFolder
            }
        ]
    },
    {
        path: '/buildings/:buildingId/edit',
        name: 'building.edit',
        component: BuildingEdit
    },
    {
        path: '/buildings/add/:id/:orgUnitId?',
        name: 'building.add',
        component: BuildingAdd
    },

    {
        path: '/users/:page?',
        name: 'users',
        component: UserList
    },
    {
        path: '/users/edit/:id',
        name: 'users.edit',
        component: UserEdit
    },
    {
        path: '/users/add',
        name: 'users.add',
        component: UserAdd
    },

    {
        path: '/organisations',
        name: 'orgs',
        component: OrgList
    },
    {
        path: '/organisations/:id',
        name: 'orgs.view',
        component: OrgView
    },
    {
        path: '/organisations/:id/edit',
        name: 'orgs.edit',
        component: OrgEdit
    },
    {
        path: '/organisations/add',
        name: 'orgs.add',
        component: OrgAdd
    },

    {
        path: '/settings',
        component: Settings,
        children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {
                path: 'profile',
                name: 'settings.profile',
                component: SettingsProfile
            },
            {
                path: 'password',
                name: 'settings.password',
                component: SettingsPassword
            }
        ]
    },

    {path: '*', component: NotFound}
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js